(function(){
    angular
        .module('maApp.view.pages')
        .controller('ActualsUnplannedController', ActualsUnplannedController);

    ActualsUnplannedController.$inject = ['ngDialog', 'ActualsUnplannedModel', '$interpolate','$scope', '$rootScope', '$log', '$routeParams'];


    function ActualsUnplannedController(ngDialog, ActualsUnplannedModel, $interpolate, $scope, $rootScope, $log, $routeParams) {

        var vm = this;
        vm.$log = $log;
        vm.handleSubmitNewUnplannedActual = handleSubmitNewUnplannedActual;
        vm.handleDeleteUnplannedActual = handleDeleteUnplannedActual;
        vm.handleUnitChanged = handleUnitChanged;
        vm.handleActionChanged = handleActionChanged;
        vm.handlePercentAffectedChanged = handlePercentAffectedChanged;
        vm.unplannedActualsSearchFilter = '';
        vm.controlState = {};
        vm.setState = setState;
        vm.getState = getState;
        vm.focusUnit = false;

        var SQ_METERS_PER_ACRE =  4046.86;

        $scope.$on("appinitialized", main);

        function emitControllerLoaded() {
            $scope.$emit('loaded', true);
        }

        function main(){

            if($rootScope.selectedProject){
                if ($rootScope.authentication.permissions.leader) {

                    setState('uaTable', 'sortType', '');
                    setState('uaTable', 'sortReverse', false);
                    loadProject();
                    ActualsUnplannedModel.fetch(vm.project)
                        .then(loadViewModel)
                        .then(createCategories)
                        .then(emitControllerLoaded);

                } else {
                    alert('You need Project Leader permissions to do that, please contact support.');
                }
            } else {
                alert('You must select a project first.');
            }

        }

        function loadViewModel(viewModel){
            vm = angular.extend(vm, viewModel);
            $log.debug('view model loaded', viewModel);
            return vm;
        }

        function createCategories(){
            vm.categories = _.uniq(  _.pluck(vm.actions, 'category')  );
        }


        function setState(obj, prop, state){
            if(  !(obj in   vm.controlState)  ){
                vm.controlState[obj] = {};
            }
            vm.controlState[obj][prop] = state;
        }

        function getState(obj, prop){
            if( ! (obj in vm.controlState) ){
                return undefined;
            }
            return vm.controlState[obj][prop];
        }

        function loadProject(){
            // if the route has a project, use that; otherwise, use the application's selected project
            vm.project = ($routeParams.project ? $routeParams.project : $rootScope.selectedProject);
        }

        function handleUnitChanged() {
            calculateCostEstimated();
        }

        function handleActionChanged() {
            calculateCostEstimated();
        }

        function handlePercentAffectedChanged(hasError) {

            // error? zero out cost estimated and return
            if (hasError)  {
                vm.newUnplannedActual.costestimated = 0;
                return;
            }

            // ensure integer
            vm.newUnplannedActual.pctaffected = Math.floor(vm.newUnplannedActual.pctaffected);

            // recalculate cost
            calculateCostEstimated();
        }

        function calculateCostEstimated() {

            // sampling unit: vm.newUnplannedActual.unit
            // action: vm.newUnplannedActual.action
            // percent: vm.newUnplannedActual.pctaffected
            // put into vm.newUnplannedActual.costestimated

            resetEstimatedCost();

            var areaAcres = 0;
            var percent = 100;  // = 100% if not specified by user
            var unitcost = 0;
            if (vm.newUnplannedActual.unit && vm.newUnplannedActual.unit.area) {
                areaAcres = parseFloat(vm.newUnplannedActual.unit.area) / SQ_METERS_PER_ACRE;
            }
            if (vm.newUnplannedActual.pctaffected) {
                percent = parseFloat(vm.newUnplannedActual.pctaffected);
            }
            if (vm.newUnplannedActual.action && vm.newUnplannedActual.action.unitcost) {
                unitcost = parseFloat(vm.newUnplannedActual.action.unitcost);
            }

            // recalculate estimated cost based on what has been entered
            // float calculation, round result to nearest dollar
            vm.newUnplannedActual.costestimated = Math.round(areaAcres * (percent / 100.0) * unitcost);
        }

        function resetEstimatedCost() {
            vm.newUnplannedActual.costestimated = 0;
        }
        
        function handleSubmitNewUnplannedActual(){
            return ActualsUnplannedModel.save(vm)
                .then(setFocus)
                .then(resetForm);

            function setFocus(){
                vm.focusUnit = true;
            }
        }

        function handleDeleteUnplannedActual(unplannedActual){
            var itemNameTemplate = '{{actionCategory}} > {{actionDescription}} at {{unitName}} on {{startDate}}';
            var itemNameOptions = {
                'actionCategory':unplannedActual.action.category,
                'actionDescription':unplannedActual.action.name,
                'unitName':unplannedActual.unit.name,
                'startDate':Date.create(unplannedActual.startdate).format('{Mon} {dd}, {yyyy}')
            };
            ngDialog.openConfirm({
                template: 'app/view/partials/confirmAction.html',
                data: {
                    'actionName': 'Remove',
                    'itemType': 'Implementation',
                    'itemName': $interpolate(itemNameTemplate)(itemNameOptions)
                }
            })
                .then(requestDelete)
                .then(removeUnplannedActualFromModel);

            function requestDelete(){
                return ActualsUnplannedModel.deleteUnplannedActual(vm.project, unplannedActual);
            }



            function removeUnplannedActualFromModel(){
                vm.unplannedActuals = _.reject(vm.unplannedActuals, rejectThisUnplannedActual);

                function rejectThisUnplannedActual(ua){
                    return ua.id == unplannedActual.id &&
                        ua.action.id == unplannedActual.action.id &&
                        ua.unit.id == unplannedActual.unit.id &&
                        ua.startdate == unplannedActual.startdate;
                }
            }
        }

        function resetForm(){
            $scope.unplannedActualForm.$setPristine();
            $scope.unplannedActualForm.$setUntouched();
        }

    }
})();